import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import $ from "jquery"; // Import jQuery if you're using it
import { useSelector } from "react-redux";
const Sidebar = () => {
  const { userType: role } = useSelector((state) => state.auth.user);
  const region = useSelector((state) => state.auth.region);
  const location = useLocation();
  useEffect(() => {
    // Sidebar toggle functionality
    $("#sidebarToggle").on("click", function (e) {
      e.preventDefault();
      $("body").toggleClass("sidebar-toggled");
      $(".sidebar").toggleClass("toggled");
    });

    // Optional: Close the sidebar if the user clicks outside of it
    $(document).on("click", function (e) {
      if (
        !$(e.target).closest(".sidebar").length &&
        !$(e.target).closest("#sidebarToggle").length
      ) {
        if ($(".sidebar").hasClass("toggled")) {
          $(".sidebar").removeClass("toggled");
          $("body").removeClass("sidebar-toggled");
        }
      }
    });

    return () => {
      // Cleanup event listeners on component unmount
      $("#sidebarToggle").off("click");
      $(document).off("click");
    };
  }, []);
  return (
    <div id="sidebar" className="sidebar">
      <ul className="sidebar navbar-nav">
        <li className="nav-item text-center">
          <Link className="navbar-brand mr-1" to="/">
            <img src="/images/Nodwin-Gaming-transparent.png" alt="Logo" />
          </Link>
        </li>
        <li className="nav-item">
          <div>MENU </div>
        </li>

        <li className="nav-item">
          <Link
            className={`nav-link ${
              location.pathname === "/dashboard" ? "active" : ""
            }`}
            to="/dashboard"
          >
            <i className="bx bx-home-circle mr-3"></i>
            <span>Dashboard</span>
          </Link>
        </li>

        {(role === 1 || role === 2) && region?.id === "2" && (
          <li className="nav-item">
            <Link
              className={`nav-link ${
                location.pathname === "/devco-dashboard" ? "active" : ""
              }`}
              to="/devco-dashboard"
            >
              <i className="bx bx-bar-chart-alt-2 mr-3"></i>
              <span>Devco Dashboard</span>
            </Link>
          </li>
        )}

        {(role === 1 || role === 2) && (
          <li className="nav-item">
            <Link
              className={`nav-link ${
                location.pathname === "/brands" ? "active" : ""
              }`}
              to="/brands"
            >
              <i className="bx bx-shape-polygon mr-3"></i>
              <span>Brands</span>
            </Link>
          </li>
        )}

        {(role === 1 || role === 2) && (
          <li className="nav-item">
            <div className="dropdown" id="settingDrp" style={{ width: "" }}>
              <button
                className="btn btn-secondary dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="false"
                aria-expanded="false"
              >
                <i className="bx bxs-package mr-3"></i>
                <span>Products</span>
                <i className="bx bxs-chevron-down ml-3"></i>
              </button>

              {/* ✅ Proper <ul> instead of <div> for dropdown menu */}
              <ul
                className="dropdown-menu list-unstyled m-0"
                aria-labelledby="dropdownMenuButton"
              >
                <li className="nav-item">
                  <Link
                    className={`nav-link ${
                      location.pathname === "/master" ? "active" : ""
                    }`}
                    to="/master"
                    index="1"
                  >
                    <i className="bx bx-layer mr-3"></i>
                    <span>Master Product</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${
                      location.pathname === "/products-denomination"
                        ? "active"
                        : ""
                    }`}
                    to="/products-denomination"
                  >
                    <i className="bx bxs-dollar-circle mr-3"></i>
                    <span>Product Variance</span>
                  </Link>
                </li>
              </ul>
            </div>
          </li>
        )}

        {role === 1 && (
          <li className="nav-item">
            <Link
              className={`nav-link ${
                location.pathname === "/bulkUpload" ? "active" : ""
              }`}
              to="/bulkUpload"
            >
              <i className="bx bx-upload mr-3"></i>
              <span>Bulk Upload</span>
            </Link>
          </li>
        )}

        {role === 1 && (
          <li className="nav-item">
            <Link
              className={`nav-link ${
                location.pathname === "/stock-transfer" ? "active" : ""
              }`}
              to="/stock-transfer"
            >
              <i className="bx bx-transfer mr-3"></i>
              <span>Stock Transfer</span>
            </Link>
          </li>
        )}

        {(role === 1 || role === 2) && (
          <li className="nav-item">
            <div
              className="dropdown"
              id="transactionOrder"
              style={{ width: "" }}
            >
              <button
                className="btn btn-secondary dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="bx bx-detail mr-3"></i>
                <span>Product Pull Request</span>
                <i className="bx bxs-chevron-down ml-3"></i>
              </button>

              {/* ✅ Corrected dropdown menu structure */}
              <ul
                className="dropdown-menu list-unstyled m-0"
                aria-labelledby="dropdownMenuButton"
              >
                <li className="nav-item">
                  <Link
                    className={`nav-link ${
                      location.pathname === "/create-order" ? "active" : ""
                    }`}
                    to="/create-order"
                  >
                    <i className="bx bxs-cart-add mr-3"></i>
                    <span>Create Pull Request</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${
                      location.pathname === "/purchased-product" ? "active" : ""
                    }`}
                    to="/purchased-product"
                  >
                    <i className="bx bx-purchase-tag mr-3"></i>
                    <span>Pull Request List</span>
                  </Link>
                </li>
              </ul>
            </div>
          </li>
        )}

        {(role === 1 || role === 2 || role === 4) && (
          <li className="nav-item">
            <Link
              className={`nav-link ${
                location.pathname === "/merchants" ? "active" : ""
              }`}
              to="/merchants"
            >
              <i className="bx bx-sitemap mr-3"></i>
              <span>Merchants</span>
            </Link>
          </li>
        )}

        {(role === 1 || role === 2) && (
          <li className="nav-item">
            <Link
              className={`nav-link ${
                location.pathname === "/merchant-requests" ? "active" : ""
              }`}
              to="/merchant-requests"
            >
              <i className="bx bx-sitemap mr-3"></i>
              <span>Merchant Requests</span>
            </Link>
          </li>
        )}

        {(role === 1 || role === 3 || role === 2 || role === 4) && (
          <li className="nav-item">
            <Link
              className={`nav-link ${
                location.pathname === "/orders" ? "active" : ""
              }`}
              to="/orders"
            >
              <i className="bx bx-file mr-3"></i>
              <span>Orders</span>
            </Link>
          </li>
        )}

        {role === 3 && (
          <li className="nav-item">
            <Link className="nav-link" to="/add-orders">
              <i className="bx bx-file mr-3"></i>
              <span>Place Order</span>
            </Link>
          </li>
        )}

        {(role === 1 || role === 3 || role === 2 || role === 4) && (
          <li className="nav-item">
            <Link
              className={`nav-link ${
                location.pathname === "/reports" ? "active" : ""
              }`}
              to="/reports"
            >
              <i className="bx bxs-bar-chart-alt-2 mr-3"></i>
              <span>Reports</span>
            </Link>
          </li>
        )}

        {(role === 1 || role === 2) && (
          <li className="nav-item">
            <div className="dropdown" id="settingDrp" style={{ width: "" }}>
              <button
                className="btn btn-secondary dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="false"
                aria-expanded="false"
              >
                <i className="bx bx-cog mr-3"></i>
                <span>Settings</span>
                <i className="bx bxs-chevron-down ml-3"></i>
              </button>

              {/* ✅ Wrap the menu items in a <ul> */}
              <ul
                className="dropdown-menu list-unstyled m-0"
                aria-labelledby="dropdownMenuButton"
              >
                <li className="nav-item">
                  <Link
                    className={`nav-link ${
                      location.pathname === "/profile" ? "active" : ""
                    }`}
                    to="/profile"
                    index="0"
                  >
                    <i className="bx bx-user mr-3"></i>
                    <span>Profile</span>
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    className={`nav-link ${
                      location.pathname === "/customer-support" ? "active" : ""
                    }`}
                    to="/customer-support"
                    index="1"
                  >
                    <i className="bx bx-support mr-3"></i>
                    <span>Customer Support</span>
                  </Link>
                </li>

                {role === 1 && (
                  <li className="nav-item">
                    <Link
                      className={`nav-link ${
                        location.pathname === "/admin-agent" ? "active" : ""
                      }`}
                      to="/admin-agent"
                    >
                      <i className="bx bxs-user mr-3"></i>
                      <span>Admin Agents</span>
                    </Link>
                  </li>
                )}

                {role === 1 && (
                  <li className="nav-item">
                    <Link
                      className={`nav-link ${
                        location.pathname === "/reseller-type" ? "active" : ""
                      }`}
                      to="/reseller-type"
                    >
                      <i className="bx bx-sitemap mr-3"></i>
                      <span>Reseller Region</span>
                    </Link>
                  </li>
                )}

                <li className="nav-item">
                  <Link
                    className={`nav-link ${
                      location.pathname === "/logs" ? "active" : ""
                    }`}
                    to="/logs"
                  >
                    <i className="bx bx-search mr-3"></i>
                    <span>Logs</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${
                      location.pathname === "/activity-logs" ? "active" : ""
                    }`}
                    to="/activity-logs"
                  >
                    <i className="bx bx-search mr-3"></i>
                    <span>Activity Logs</span>
                  </Link>
                </li>
              </ul>
            </div>
          </li>
        )}

        {role === 1 && (
          <li className="nav-item">
            <Link
              className={`nav-link ${
                location.pathname === "/customer-info" ? "active" : ""
              }`}
              to="/customer-info"
            >
              <i className="bx bxs-bar-chart-alt-2 mr-3"></i>
              <span>Customer Info</span>
            </Link>
          </li>
        )}
      </ul>
    </div>
  );
};

export default Sidebar;
